import React, { Component, Fragment } from 'react';
import { COLLABORATION_PARTIAL_CLOSE, COLLABORATION_REOPEN } from 'fixtures/collabTypes';
import { CONFORMITY_REPORT } from 'fixtures/api';
import Breadcrumb from 'molecules/Breadcrumb';
import CollabSidebar from 'organisms/CollaborationSidebar';
import CollabContent from 'organisms/CollaborationContent';
import CloseTaskModal from 'organisms/CloseTaskModal';
import ReopenTaskModal from 'organisms/ReopenTaskModal/index';
import CollabTemplate from 'templates/CollaborationPage';
import ModalPage from 'templates/ModalPage';
import { submitCollaboration } from 'services/collabService';
import { toggleIsShowTab } from 'Redux/actions/ViewStateActions';
import { setTaskData } from 'Redux/actions/TaskActions';
import { getCollabByType } from 'Redux/actions/CollabActions';
import { getAllDeptsData } from 'Redux/actions/DepartmentListActions';
import { getCCsData } from 'Redux/actions/CCListActions'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

class ConformityCollab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoadingTask: false,
      isLoadingDept: false,
      isLoadingCollab: false,
      isClosing: false,
      closingModalShown: false,
      closingData: {
        remark: '',
        rootCause: '',
        corrective: '',
        preventive: '',
        evidences: [],
      },
      isReopening: false,
      reopenModalShown: false,
      reopenData: {
        reason: '',
      },
      navList: [
        'Task',
        'Task List Unconformity',
        'Collaborations Unconformity'
      ]
    }
  }

  componentDidMount() {
    const { match: { params: { taskId } }, toggleIsShowTab, } = this.props
    toggleIsShowTab(false)
    this.init(taskId)
  }

  componentDidUpdate(prevProps) {
    const { taskData, collabData, deptsList, match: { params: { taskId } } } = this.props
    const { isLoadingTask, isLoadingDept, isLoadingCollab } = this.state
    if (prevProps.taskData !== taskData && isLoadingTask) {
      this.setState({ isLoadingTask: false })
    }

    if (prevProps.deptsList !== deptsList && isLoadingDept) {
      this.setState({ isLoadingDept: false })
    }

    if (prevProps.collabData !== collabData && isLoadingCollab) {
      this.setState({ isLoadingCollab: false })
    }

    if (prevProps.match.params.taskId !== taskId) {
      this.init(taskId)
    }
  }

  // method for initializing get parent task data and collab data
  init(taskId) {
    this.setState({
      isLoadingTask: true,
      isLoadingDept: true,
      isLoadingCollab: true
    }, () => {
      this.props.setTaskData(CONFORMITY_REPORT, taskId)
      this.props.getCollabByType(CONFORMITY_REPORT, taskId)
      this.props.getAllDeptsData()
    })
  }

  onClosingDataChange(val, field) {
    const closingData = Object.assign(this.state.closingData)

    if (field === 'evidences') {
      const files = []

      for (var i = 0; i < val.length; i++) {
        const file = val[i]
        let reader = new FileReader()
        reader.addEventListener("load", (event) => {
          files.push({
            name: file.name,
            type: `.${file.name.split('.')[file.name.split('.').length -1]}`,
            fileBase64: event.target.result.split(',')[1]
          })
          closingData[field] = files
          this.setState({ closingData })
        })
        reader.readAsDataURL(file)
      }
    } else {
      closingData[field] = val
    }

    this.setState({ closingData })
  }

  removeEvidence(index) {
    this.setState(({ closingData }) => ({
      closingData: {
        ...closingData,
        evidences: [
          ...closingData.evidences.slice(0, index),
          ...closingData.evidences.slice(index + 1),
        ]
      }
    }))
  }

  onReopenDataChange(val, field) {
    const reopenData = Object.assign(this.state.reopenData)
    reopenData[field] = val
    this.setState({ reopenData })
  }

  // method for closing the issue
  closeIssue() {
    const { closingData } = this.state
    const { taskData, userLogin: { userDetail } } = this.props
    const content = {
      displayName: userDetail.displayName,
      departmentName: userDetail.department.nameDisplay,
      evidences: closingData.evidences.map(e => ['.png', '.jpg'].includes(e.type)
        ? ({
          type: 'IMAGE',
          fileBase64: e.fileBase64
        })
        : ({
          type: 'DOCUMENT',
          fileBase64: e.fileBase64,
          nameDisplay: e.name
        })
      ),
      ...(
        userDetail.userRole === 'INTERNAL'
          ? {
            remark: closingData.remark,
          }
          : {
            rootCause: closingData.rootCause,
            corrective: closingData.corrective,
            preventive: closingData.preventive,
          }
      )
    }

    this.setState({ isClosing: true }, async () => {
      submitCollaboration(
        COLLABORATION_PARTIAL_CLOSE,
        content,
        userDetail,
        taskData.id,
        CONFORMITY_REPORT,
        this.switchModal.bind(this)
      )
    })
  }

  reopenIssue() {
    const { reopenData } = this.state
    const { taskData, userLogin: { userDetail } } = this.props
    const content = {
      displayName: userDetail.displayName,
      departmentName: userDetail.department.nameDisplay,
      reason: reopenData.reason
    }

    this.setState({ isReopening: true }, () => {
      submitCollaboration(
        COLLABORATION_REOPEN,
        content,
        userDetail,
        taskData.id,
        CONFORMITY_REPORT,
        this.switchReopenModal.bind(this)
      )
    })
  }

  switchModal() {
    this.setState(({ closingModalShown }) => ({ closingModalShown: !closingModalShown }))
  }

  switchReopenModal() {
    this.setState(({ reopenModalShown }) => ({ reopenModalShown: !reopenModalShown }))
  }

  render() {
    const {
      isLoadingTask,
      isLoadingDept,
      isLoadingCollab,
      isClosing,
      closingModalShown,
      closingData,
      isReopening,
      reopenModalShown,
      reopenData,
      navList
    } = this.state
    const {
      deptsList,
      ccsList,
      taskData,
      collabData,
      getCCsData,
      userLogin,
      ...rest
    } = this.props

    const canReopen = (userLogin && taskData)
      && userLogin.userDetail.departmentId === taskData.user.departmentId
      && (
        taskData.isClosed
        || (taskData.sharedDepartment && taskData.sharedDepartment.partialClose && taskData.sharedDepartment.partialClose.length)
      )
    const isContractor = !!userLogin.userDetail.contractorId

    const requireCorrective = taskData && taskData.anyFurtherAction
      ? !!closingData.corrective
      : true
    const canSubmitClosingData =
      (!isContractor && !!closingData.remark)
      || (isContractor && !!closingData.rootCause && requireCorrective)

    return (
      <Fragment>
        <Breadcrumb navList={navList} mb={'10px'} />
        {isLoadingTask ?
          <span>Loading...</span> :
          // mount the page's template and the components
          <CollabTemplate
            left={
              <CollabSidebar
                data={taskData}
                isClosing={isClosing}
                onCloseIssue={this.switchModal.bind(this)}
                push={this.props.history.push}
                pathToList={this.props.match.path.split(':')[0]}
                reopen={this.switchReopenModal.bind(this)}
                canReopen={canReopen}
              />
            }
            right={
              <CollabContent
                data={collabData}
                taskData={taskData}
                depts={deptsList}
                ccsList={ccsList}
                getCCsData={getCCsData}
                isLoadingInput={isLoadingDept}
                isLoadingData={isLoadingCollab}
                taskType={CONFORMITY_REPORT}
                userLogin={userLogin}
                {...rest}
              />
            }
          />
        }
        <ModalPage
          isOpen={closingModalShown}
          fnSwitch={this.switchModal.bind(this)}
          contentChild={
            <CloseTaskModal
              data={closingData}
              task={taskData}
              fnSwitch={this.switchModal.bind(this)}
              fnChange={this.onClosingDataChange.bind(this)}
              fnSubmit={this.closeIssue.bind(this)}
              fnRemoveEvidence={this.removeEvidence.bind(this)}
              isDisabled={isClosing || !canSubmitClosingData}
              isClosing={isClosing}
              isContractor={isContractor}
            />
          }
        />
        <ModalPage
          isOpen={reopenModalShown}
          fnSwitch={this.switchReopenModal.bind(this)}
          contentChild={
            <ReopenTaskModal
              data={reopenData}
              fnSwitch={this.switchReopenModal.bind(this)}
              fnChange={this.onReopenDataChange.bind(this)}
              fnSubmit={this.reopenIssue.bind(this)}
              isDisabled={isReopening || !reopenData.reason}
            />
          }
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    deptsList: state.deptsList,
    ccsList: state.ccsList,
    taskData: state.currentConformityRep,
    collabData: state.collabConformityReport,
    userLogin: state.userLogin
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCollabByType,
      getAllDeptsData,
      getCCsData,
      setTaskData,
      toggleIsShowTab
    },
    dispatch
  )

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConformityCollab)
);
